export default __webpack_public_path__ + "static/media/medical_icon.35220066.png";